import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { UserService } from './user.service';

@Injectable({
    providedIn: 'root'
})
export class BrowserService {

    constructor(
        private platform: Platform,
        private inAppBrowser: InAppBrowser,
        private userService: UserService
    ) {
    }

    async open(url: string) {
        await this.userService.updateAuthCookies();
        if (!this.platform.is('hybrid') || this.platform.is('desktop')) {
            window.open(url);
        } else {
            this.inAppBrowser.create(url, '_blank','toolbarposition=top,hideurlbar=yes');
        }
    }
}
